var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TreeMarker',{attrs:{"id":_vm.tree.treeId,"lat":_vm.lat,"lng":_vm.lng,"icon":_vm.icon},on:{"marker-click":function($event){return _vm.$emit("marker-click", $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }